import { FIELDS } from '../constants/wbHBBuilderConstants';

export const parseHexToColor = (colorStr) => {
  if (colorStr === null || typeof colorStr === 'undefined') {
    return {
      color: FIELDS.COLOR.BACKGROUND,
      opacity: FIELDS.OPACITY,
    };
  }

  const color = colorStr.substr(1);

  let str;
  let opacity = 1;
  let opacityStr;

  // RGB
  switch (color.length) {
    case 3:
      break;
    case 6:
      str = '#' + color;
      opacity = 1;
      break;
    case 8:
      opacityStr = color.substr(0, 2);
      str = '#' + color.substr(2, 6);
      opacity = parseInt(opacityStr, 16) / 100;
      break;
    default:
      throw new TypeError('Color provided does not match RGB or RGBA pattern');
  }

  opacity = opacity * 100;

  return {
    color: str,
    opacity,
  };
};

export const convertBgToHex = ({ color, opacity }) => {
  const opacityString = opacity.toString(16);
  const rgbHex = color.substr(1);
  const hexColor = `#${opacityString}${rgbHex}`;
  return hexColor;
};

export const convertHexToRGBA = (hexCode, opacity = 1) => {
  let hex = hexCode.replace('#', '');

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  /* Backward compatibility for whole number based opacity values. */
  if (opacity > 1 && opacity <= 100) {
    opacity = opacity / 100;
  }

  return {
    colorStyle: `rgba(${r},${g},${b},${opacity})`,
    values: {
      r,
      g,
      b,
      a: opacity,
    },
  };
};

export const convertFieldColor = (colorValue) => {
  const { color, opacity } = parseHexToColor(colorValue);
  return convertHexToRGBA(color, opacity).colorStyle;
};

export const convertFieldColorToRGBA = (bg) => {
  const { color } = parseHexToColor(bg.color);
  return convertHexToRGBA(color, bg.opacity).colorStyle;
};
